<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import { y, hideLabels } from '../stores.js'
  import Header from './header.svelte'
  import Home from './home.svelte'
  import Weights from './sections/weights.svelte'
  import Details from './sections/details.svelte'
  import Glyphset from './sections/glyphset.svelte'
  import Alternates from './sections/alternates.svelte'
  import Story from './sections/story.svelte'
  import Specimens from './sections/specimens.svelte'
  import Label from './label.svelte'

  export let section
  export let id
  export let i

  let title = section.title
  let content = section.content
  let fullscreen = section.fullscreen

  function isOdd(number) {
    return number % 2 === 0
  }

  // links a component to an id and set up labels positions and speed
  const contentMap = [
    {
      name: 'home',
      component: Home,
      labels: [
        { col: '8 / span 2', y: '65%', speed: 0.2 },
        { col: '4 / span 1', y: '70%', speed: 1.4 },
        { col: '6 / span 2', y: '45%', speed: 2.4 },
        { col: '7 / span 2', y: '30%', speed: 0.5 },
        { col: '10 / span 1', y: '60%', speed: 0.3 },
      ],
    },
    {
      name: 'weights',
      component: Weights,
      labels: [
        { col: '2 / span 1', y: '60%', speed: 0.2 },
        { col: '4 / span 6', y: '80%', speed: 0.8 },
      ],
    },
    {
      name: 'principles',
      component: Details,
      labels: [
        { col: '3 / span 3', y: '35%', speed: 0.15 },
        { col: '4 / span 5', y: '40%', speed: 0.5 },
        { col: '7 / span 2', y: '70%', speed: 0.6 },
      ],
    },
    {
      name: 'alphabet',
      component: Glyphset,
      labels: [
        { col: '2 / span 2', y: '40%', speed: 0.8 },
        { col: '8 / span 2', y: '50%', speed: 0.2 },
        { col: '8 / span 2', y: '10%', speed: 0.4 },
        { col: '2 / span 2', y: '70%', speed: 0.2 },
      ],
    },
    {
      name: 'try',
      component: Alternates,
      labels: [{ col: '7 / span 2', y: '60%', speed: 0.2 }],
    },
    {
      name: 'story',
      component: Story,
    },
    { name: 'specimens', component: Specimens },
  ]

  let component = contentMap.find((x) => x.name === section.name).component
  let labelProps = contentMap.find((x) => x.name === section.name).labels

  let wrapper
  let parallax
  let top
  onMount(() => {
    let scrollInstance = ScrollTrigger.create({
      trigger: wrapper,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        parallax = true
      },
      onLeave: () => {
        parallax = false
      },
      onEnterBack: () => {
        parallax = true
      },
      onLeaveBack: () => {
        parallax = false
      },
    })
    setTimeout(() => {
      ScrollTrigger.refresh()
    }, 400)
    return () => {
      scrollInstance.kill()
      gsap.killTweensOf('*')
    }
  })

  function updatePos($y) {
    top = wrapper.getBoundingClientRect().top
  }

  $: if (wrapper) {
    updatePos($y)
  }
</script>

<section
  bind:this={wrapper}
  class={isOdd(i) ? 'red' : 'green'}
  class:fullscreen
  {id}
  out:fade={{ duration: 300 }}>
  <div class="content-wrapper">
    <div
      class={section.name === 'home' ? 'fullscreen labels-grid' : 'labels-grid'}>
      {#if labelProps && !$hideLabels}
        {#each labelProps as label, i}
          <div
            class="label"
            style="
              grid-column:{label.col};
              grid-row: 1;
              position: relative;
              top: {label.y};
              z-index: 3;
              height: 0;
              --transformation: {top * label.speed}px;
              {parallax ? 'transform: translateY(var(--transformation));' : ''}
              "
            transition:fade={{ duration: 200 }}>
            <Label img={content.labels[i].path} name={content.labels[i].name} />
          </div>
        {/each}
      {/if}
      <div class="content-inner">
        <Header {title} />
        <svelte:component this={component} {content} />
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  @import '../responsive.scss';

  section {
    width: 100vw;
    padding: 1em 3em 6em 3em;
    scroll-margin-top: 60px;

    @include for-phone {
      padding: 1em 1em 3em 1em;
    }
  }
  .fullscreen {
    min-height: 100vh;
  }

  .labels-grid {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    height: 100%;
  }
  .content-inner {
    grid-column: 1 / span 10;
    grid-row: 1;
  }

  .label {
    @include for-phone {
      width: 200%;
    }
  }

  .hide {
    display: none;
    visibility: none;
  }

  .red {
    background-color: var(--red);
  }

  .green {
    background-color: var(--green);
  }
</style>
